import { render, staticRenderFns } from "./edpUpload.vue?vue&type=template&id=4e49964c&"
import script from "./edpUpload.vue?vue&type=script&lang=js&"
export * from "./edpUpload.vue?vue&type=script&lang=js&"
import style0 from "./edpUpload.vue?vue&type=style&index=0&id=4e49964c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports